import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-vehical-popup',
    templateUrl: './vehical-popup.component.html',
    styleUrl: './vehical-popup.component.scss',
    standalone: false
})
export class VehicalPopupComponent {

    constructor(private dialogRef: MatDialogRef<VehicalPopupComponent>) { }

    closePopup() {
        this.dialogRef.close();
    }

}
